export default __webpack_public_path__ + "static/N0005-fc563a9c4dc3ebb23000e79a0d3d5a82.png";